import { createRouter, createWebHistory } from 'vue-router';
import { getRuntimeConfig } from '@/config';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'submit',
      component: () => import('@/pages/submit-page.vue'),
      meta: { featureKey: 'recipeSubmission' as const },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/pages/privacy-page.vue'),
    },
    {
      path: '/unavailable',
      name: 'unavailable',
      component: () => import('@/pages/unavailable-page.vue'),
    },
    // Any unknown path is almost certainly a mistyped or stale link. Send them to the
    // form rather than showing an error page they can do nothing with.
    { path: '/:pathMatch(.*)*', redirect: { name: 'submit' } },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

/**
 * Blocks a route whose module has been switched off at build time. This is the
 * "is it deployed" question — whether submissions are open today is decided at runtime by
 * the settings the page loads.
 */
router.beforeEach((to) => {
  const featureKey = to.meta.featureKey as 'recipeSubmission' | 'ordering' | undefined;
  if (!featureKey) return true;

  const { featureFlags } = getRuntimeConfig();
  if (featureFlags[featureKey]) return true;

  return { name: 'unavailable' };
});

export default router;
